/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../../utils/money';
import { HorseLink } from '../../../shared/links/ProfileLink';
import { numericAndDashSort } from '../../../utils/number';

const columns = isBroodmare => [
    {
        key: 'horseUid',
        header: 'horse',
        cell: HorseLink,
    },
    {
        key: 'damSireUid',
        header: isBroodmare ? 'sire' : 'dam\'s sire',
        cell: ({ damSireStyleName, damSireUid, sireStyleName, sireUid }) => (
            <HorseLink
                horseStyleName={damSireStyleName || sireStyleName}
                horseUid={damSireUid || sireUid}
            />
        ),
    },
    {
        key: 'wins',
    },
    {
        key: 'runs',
    },
    {
        key: 'winsPercent',
        header: '%',
    },
    {
        key: 'totalPrizemoney',
        header: 'total earnings',
        cell: ({ totalPrizemoney }) => formatMoney(totalPrizemoney),
    },
    {
        key: 'rpPostmark',
        header: 'rpr',
        sortFn: numericAndDashSort('rpPostmark'),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progenyStatistics/raceRow/columns.jsx